export default __webpack_public_path__ + "static/media/landing.898a2b35.svg";